var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lazy-image-wrapper",class:{ loaded: _vm.isLoaded }},[_c('img',{ref:"img",staticClass:"lazy-image",class:{ 'fade-in': _vm.isLoaded },attrs:{"data-src":_vm.src,"alt":_vm.alt},on:{"load":_vm.onLoad}}),(!_vm.isLoaded)?_c('div',{staticClass:"lazy-placeholder"},[_c('div',{staticClass:"spinner"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }